import Bluebird from 'bluebird';
import CacheG from '../../../services/cache';
import environment, { Environment } from '../../../services/environment';
import ajax from './ajax';
import { isExternal, pageLang } from './app-storage';
import host from './current-host';

const cache = new CacheG<TranslationStrings[keyof TranslationStrings]>();

export default async function getTranslations<T extends keyof TranslationStrings>(
    key: T,
    language = pageLang
): Bluebird<TranslationStrings[T]> {

    // From cache
    const cached = cache.find(key) as TranslationStrings[T];
    if (cached) {
        return cached;
    }

    // From server
    const url = getServerUrl();

    return ajax<TranslationStrings[T]>(
        'GET',
        `${url}/api/translations/${language}/${key}`)
        .then(translations => {
            cache.set(key, translations);
            return translations;
        });
}

function getServerUrl(): string {
    if (typeof window.GETE !== 'undefined'
        && typeof window.GETE.widgetOptions !== 'undefined'
        && typeof window.GETE.widgetOptions.src !== 'undefined') {
        // Use host from widget
        return window.GETE.widgetOptions.src;
    }

    if (isExternal && environment !== Environment.Development) {
        // External hosts should be able to use the translation host from the widget
        throw new Error('Cannot retrieve translations: Server host is unknown');
    }

    return host;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/translations.ts